import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f66574a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66574a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f66574a')) {
      api.createRecord('3f66574a', component.options)
    } else {
      api.reload('3f66574a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f66574a&scoped=true", function () {
      api.rerender('3f66574a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/companySkus/index.vue"
export default component.exports